import { isEmpty } from 'lodash';
import { FC, useEffect, useRef, useState } from 'react';

import { ReactComponent as IconArrow } from '../../../../../assets/images/arrow.svg';

import './index.scss';

interface OwnProps {
    data: string[] | number[];
    dataKind?: string;
    defaultSelected?: string | number;
    disabled?: boolean;
    onSelect: (v: string | number) => void;
}

type Props = OwnProps;

export const Dropdown: FC<Props> = ({ data, dataKind, onSelect, defaultSelected = '', disabled }) => {
    const [open, setOpen] = useState<boolean>(false);
    const [value, setValue] = useState<string | number>(defaultSelected);
    const ref = useRef<HTMLDivElement | null>(null);

    useEffect(() => setValue(defaultSelected), [defaultSelected]);

    useEffect(() => {
        const handleClose = (e: Event): void => {
            if (!ref.current?.contains(e.target as HTMLDivElement)) {
                setOpen(false);
            }
        };

        window.addEventListener('click', handleClose);
        return () => window.removeEventListener('click', handleClose);
    }, []);

    return (
        <div className={open ? 'dropdown active' : 'dropdown'} onClick={() => setOpen(!open)} ref={ref}>
            <div className="dropdown__text">
                <div>
                    {value && (
                        <>
                            {value}
                            {dataKind}
                        </>
                    )}
                </div>
                <IconArrow />
            </div>

            <div className="dropdown__items">
                {!isEmpty(data) &&
                    // @ts-ignore
                    data.map((item: string | number) => (
                        <div
                            onClick={() => {
                                if (disabled) return;
                                setValue(item);
                                onSelect(item);
                            }}
                            className="dropdown__item"
                            key={item}
                        >
                            {item}
                        </div>
                    ))}
            </div>
        </div>
    );
};
